import React, { useEffect, useRef, useState } from "react";
import {
  DateInput,
  SelectInput,
  TextInput,
} from "../../components/common/ui/Inputs";
import Button from "../../components/common/ui/Button";
import Table from "../../components/common/table/Table";
import { history } from "../../_helpers";
import ExcelExport from "../../components/common/ui/Export/ExcelExport";
import { useDispatch, useSelector } from "react-redux";
import { masterActions, staffRequestAction, authActions, managementUserAction } from "../../_store";
import generateXlsx from "../../components/common/export/generateXlsx";
import CustomLoader from "../../components/common/ui/Loader";
import { showToastNotification } from "../../components/common/ui/NotificationModal/ToastNotication";
import { Popup } from "../../components/common/ui/NotificationModal/Popup";
import { fDate, getCurrentDate, MinDate, Today } from "../../utils/formatTime";
import { UserRoleType } from "../../_helpers/enumerator";
import { getStoredValue } from "../../_helpers/storagehelper";

function PrivateConversation() {
  const dispatch = useDispatch();
  const facilityCode = useSelector((x) => x?.auth?.commonFacilityCode);
  const [showSearchFields, setShowSearchFields] = useState(false);
  // const prevFacilityCodeRef = useRef(facilityCode);
  const [isshowAcceptbtn, setIsshowAcceptbtn] = useState(false);

  const { privateConversationList, loading } = useSelector(
    (x) => x?.staffRequest
  );
  const { RequestStatus } = useSelector((x) => x?.dropdownOptions);
  const {
    requestReview,
    PODList,
    privateConvoAcceptRequestReponse,
    privateConversationSearchListData,
  } = useSelector((x) => x?.staffRequest);
  // const STAFF_REQUEST_ACCESSIBLE_FA = [974];
  const PC_REQUEST_VIEWERS = JSON.parse(process.env.REACT_APP_PCR_REQUESTFORM_VIEWERS);

  const loggedUser = getStoredValue("user")?.ManagementUserID;

  const UserRoleID = getStoredValue("user")?.UserRoleID;

  const [reviewFullData, setReviewFullData] = useState([]);

  const prevFacilityCodeRef = useRef(facilityCode);

  const { isSignalRData } = useSelector((state) => state.auth);
  // const [privateConversationSearch, setPrivateConversationSearch] = useState({
  //   FacilityID: facilityCode,
  //   InmatesId: 0,
  //   InmateResidentID: "",
  //   PodID: 0,
  //   InmateFirstName: "",
  //   InmateLastName: "",
  //   RequestCurrentStatus: 2,
  //   RequestCreateStartDate: "",
  //   RequestCreateEndDate: "",
  //   RequestRespondStartDate: "",
  //   RequestRespondEndDate: "",
  //   managementUserID: loggedUser,
  //   PageNo: 1,
  //   RowCountPerPage: 10,
  //   exportExcel: false,
  //   exportPDF: false,
  // });

  //load facility drop down
  useEffect(() => {
    dispatch(
      masterActions.LoadFacilityDropDown({
        facilityID: 0,
        activeStatus: 1,
      })
    );
    if (loggedUser != 1) {
      const ManagementUserID = loggedUser;
      const FacilityID = facilityCode
      dispatch(managementUserAction.LoadUserAccessibleRequestForm({ ManagementUserID, FacilityID })).then((x) => {
        if (x?.payload?.length > 0) {
          const PCRForm = x?.payload?.find((x) => x?.RequestFormTypeID == 61);
          setIsshowAcceptbtn(PCRForm?.FormRespond == 1 ? true : false);
        }
      })
    }
  }, []);



  useEffect(() => {
    dispatch(
      masterActions.GetPublicDefenderNotificationAlert({
        ManagementUserID: loggedUser,
        FacilityID: facilityCode,
      })
    ).then((response) => {
      const updatedMenuList =
        getStoredValue("menu_list") || response?.payload;

      if (updatedMenuList) {
        dispatch(authActions.updateMenuList(updatedMenuList));
      }
    });

    dispatch(
      staffRequestAction?.LoadPrivateConversationRequestUnreadCount({
        ManagementUserID: loggedUser,
        FacilityID: facilityCode,
      })
    );
  }, []);

  useEffect(() => {
    if (prevFacilityCodeRef.current !== facilityCode && facilityCode === 0) {
      history.navigate("StaffRequestList");
    }
  }, [facilityCode]);

  // useEffect(() => {
  //   if (prevFacilityCodeRef.current !== facilityCode) {
  //     history.navigate("StaffRequestList");
  //   }
  // }, [facilityCode]);

  useEffect(() => {
    switch (privateConvoAcceptRequestReponse?.IsSucceed) {
      case 1:
        showToastNotification(
          "Private conversation Request Accepted Succesfully.",
          "success"
        );
        //list call
        dispatch(staffRequestAction?.resetForm());
        const searchData = { ...privateConversationSearchListData };
        searchData.FacilityID = facilityCode;
        searchData.managementUserID = loggedUser;
        dispatch(staffRequestAction?.getPrivateConversationList(searchData));
        break;

      case -2:
        showToastNotification(
          "Already this form has Accepted other Staff User.",
          "error"
        );
        break;

      case -1:
        showToastNotification("Operation Failed.", "error");
        break;

      default:
        break;
    }
  }, [privateConvoAcceptRequestReponse]);

  useEffect(() => {
    if (facilityCode === 0) return;
    dispatch(staffRequestAction?.getPODList(facilityCode))
      .then((result) => {
        const PODList = result?.payload;
        PODList?.unshift({ value: 0, label: "-- ALL --" });
        dispatch(staffRequestAction?.updatePODList(PODList));
      })
      .catch((err) => {
        showToastNotification("Failed to get POD List", "error");
      });
  }, [facilityCode]);

  useEffect(() => {
    if (facilityCode === 0) return;
    const searchData = { ...privateConversationSearchListData };
    searchData.FacilityID = facilityCode;
    searchData.managementUserID = loggedUser;
    dispatch(staffRequestAction?.getPrivateConversationList(searchData))
      .then((result) => {
        if (result?.payload?.DataList?.length === 0) {
          const searchParams = { ...privateConversationSearchListData };
          if (searchParams.PageNo != 1 || searchParams.RowCountPerPage != 10) {
            searchParams.PageNo = 1;
            searchParams.RowCountPerPage = 10;
            dispatch(
              staffRequestAction?.setPrivateConversationSeachList(searchParams)
            );
            dispatch(
              staffRequestAction?.getPrivateConversationList(searchParams)
            );
          }
        }
      })
      .catch((err) => { });
  }, [
    facilityCode,
    privateConversationSearchListData?.RowCountPerPage,
    privateConversationSearchListData?.PageNo,
  ]);




  //signalR
  // useEffect(() => {
  //   if (isSignalRData?.type == "Request_AdminRemedy_CUD") {
  //     if (facilityCode === 0) return;
  //     const searchData = { ...privateConversationSearchListData };
  //     searchData.FacilityID = facilityCode;
  //     searchData.managementUserID = loggedUser;
  //     searchData.isNoLoading = true;
  //     dispatch(staffRequestAction?.getPrivateConversationList(searchData))
  //       .then((result) => {
  //         if (result?.payload?.DataList?.length === 0) {
  //           const searchParams = { ...privateConversationSearchListData };
  //           searchParams.PageNo = 1;
  //           searchParams.RowCountPerPage = 10;
  //           searchParams.isNoLoading = true;
  //           dispatch(
  //             staffRequestAction?.setPrivateConversationSeachList(searchParams)
  //           );
  //           dispatch(
  //             staffRequestAction?.getPrivateConversationList(searchParams)
  //           );
  //         }
  //       })
  //       .catch((err) => { });
  //   }
  // }, [isSignalRData]);

  const handleAcceptRequest = (row) => {
    Popup({
      title: "Message",
      text: `Do you want to accept this request..?`,
      icon: "info",
      confirmButtonText: "YES",
      cancelButtonText: "NO",
      onConfirm: () => {
        dispatch(
          staffRequestAction?.privateConvoAcceptRequest({
            ManagementUserID: loggedUser,
            RequestFormTypeID: row?.RequestFormTypeID,
          })
        );
      },
    });
  };

  const PCRFormView = (row) => {
    if (row?.IsAcceptPCR === 0) return;

    if (
      row?.RequestFormType >= 3 &&
      row?.RequestFormType !== 53 &&
      row?.RequestFormType !== 59 &&
      row?.RequestFormType !== 60
    ) {
      history.navigate("StaffRequestList/PrivateConversationRequestForm", {
        state: {
          formID: row?.RequestFormTypeID,
          RequestFormType: row?.RequestFormType,
          InmateID: row?.InmateID,
          InmateResidentId: row?.InmateResidentId,
        },
        source: "privateConversation",
      });
    }
  };

  const columns = [
    {
      width: "180px",
      name: "Conversation ID",
      key: "RequestForumThreadID",
      selector: (row) => row.PCRequestID,
      cell: (row) => (
        <div className="d-flex gap-2">
          <div
            className={row?.IsAcceptPCR === 1 ? "Common_Link_Style" : ""}
            onClick={() => viewForm(row, reviewFullData)}
          >
            <div>{row.PCRequestID}</div>
          </div>
          {row?.UserRequestReadStatus === 0 && (
            <div class="newbutton-container">
              New
              <div class="border-animation"></div>
            </div>
          )}
        </div>
      ),

      sortable: true,
    },

    {
      width: "100px",
      name: "Inmate ID",
      key: "InmateResidentId",
      selector: (row) => row.InmateResidentId,
      sortable: true,
    },
    {
      name: "Inmate Full Name",
      key: "InmateName",
      selector: (row) => row.InmateName,
      sortable: true,
    },

    {
      name: "POD",
      key: "PODCode",
      selector: (row) => row.PodCode,
      sortable: true,
    },
    {
      name: "Created Date",
      key: "RequestCreateDate",
      selector: (row) => row.RequestCreateDate,
      sortable: true,
    },
    {
      name: "Responded By",
      key: "PCRAcceptedMGUFullname",
      selector: (row) =>
        row.PCRAcceptedMGUFullname ? row.PCRAcceptedMGUFullname : "-",
      sortable: true,
    },
    {
      name: "Responded On",
      key: "RequestRespondDate",
      selector: (row) =>
        row.RequestRespondDate ? row.RequestRespondDate : "-",
      sortable: true,
      center: true,
    },
    {
      width: "80px",
      name: "Status",
      key: "RequestCurrentStatus",
      selector: (row) => row.RequestCurrentStatus,
      cell: (row) =>
        row.RequestCurrentStatus === "Open" ? (
          <span style={{ marginleft: "10px" }} className="status-open">
            Open
          </span>
        ) : (
          <span style={{ marginleft: "10px" }} className="status-closed">
            Closed
          </span>
        ),
      sortable: true,
      center: true,
      sortFunction: (rowA, rowB) => {
        // Ensuring case-insensitive sorting
        const statusA = rowA.RequestCurrentStatus.toLowerCase();
        const statusB = rowB.RequestCurrentStatus.toLowerCase();

        if (statusA < statusB) {
          return -1;
        }
        if (statusA > statusB) {
          return 1;
        }
        return 0;
      },
    },
    ...(!PC_REQUEST_VIEWERS?.includes(loggedUser)
      ? [
        {
          name: "Action",
          key: "IsAcceptPCR",
          selector: (row) => row.ActiveStadtus,
          cell: (row) =>
            row.IsAcceptPCR === 1 ? (
              <span className="status-open">Accepted</span>
            ) : (
              <Button
                label="Accept Request"
                type="button"
                onClick={() => handleAcceptRequest(row)}
                variant="success"
                status={"success"}
                disabled={isshowAcceptbtn ? false : true}
                className={"btn-xs"}
              />
              // <span
              //   className="status-Closed text-center cursor-pointer"
              //   onClick={() => {
              //     handleAcceptRequest(row);
              //   }}
              // >
              //   Accept Request
              // </span>
            ),
          sortable: true,
          left: true,
        },
      ]
      : []),
  ];

  const handleRowPerPage = (page) => {
    const search = { ...privateConversationSearchListData };
    search.RowCountPerPage = page;
    search.PageNo = 1;
    dispatch(staffRequestAction?.setPrivateConversationSeachList(search));
    // setPrivateConversationSearch((prevState) => ({
    //   ...prevState,
    //   RowCountPerPage: page,
    // }));
  };

  const handlePageChange = (page) => {
    if (sorting) {
      sorting = false;
      return;
    }
    const search = { ...privateConversationSearchListData };
    search.PageNo = page;
    dispatch(staffRequestAction?.setPrivateConversationSeachList(search));
    // setPrivateConversationSearch((prevState) => ({
    //   ...prevState,
    //   PageNo: page,
    // }));
  };

  let sorting = false; // to restrict the pagination issue
  const handleSort = (column, sortDirection) => {
    if (!column?.key) return;
    sorting = true;
    const search = { ...privateConversationSearchListData };
    const newSortOrder = search.SortBy.includes(column.key)
      ? search.SortBy.endsWith("ASC")
        ? "DESC"
        : "ASC"
      : "ASC";

    search.FacilityID = facilityCode;
    search.managementUserID = loggedUser;
    search.SortBy = `${column.key} ${newSortOrder}`;
    dispatch(staffRequestAction?.setPrivateConversationSeachList(search));
    dispatch(
      staffRequestAction?.getPrivateConversationList({
        ...search,
        SortBy: `${column.key} ${newSortOrder}`,
      })
    );
  };

  const handleChange = (e, select) => {
    const search = { ...privateConversationSearchListData };
    // search.PageNo = 1;
    // search.RowCountPerPage = 10;
    if (
      select === "RequestCreateStartDate" ||
      select === "RequestCreateEndDate" ||
      select === "RequestRespondStartDate" ||
      select === "RequestRespondEndDate"
    ) {
      search[select] = fDate(e);
      dispatch(staffRequestAction?.setPrivateConversationSeachList(search));
      // setPrivateConversationSearch({
      //   ...privateConversationSearch,
      //   [select]: fDate(e),
      // });
      return;
    }
    if (select === "RequestCurrentStatus" || select === "PodID") {
      // const searchData = { ...privateConversationSearch };
      search[select] =
        e?.value !== undefined ? e?.value : select === "PodID" ? 0 : 2;
      search.FacilityID = facilityCode;
      // search.PageNo = 1;
      //search.RowCountPerPage = 10;
      search.managementUserID = loggedUser;
      search.PageNo = 1;
      search.RowCountPerPage = 10;
      dispatch(staffRequestAction?.getPrivateConversationList(search));
      dispatch(staffRequestAction?.setPrivateConversationSeachList(search));

      // setPrivateConversationSearch({
      //   ...privateConversationSearch,
      //   [select]:
      //     e?.value !== undefined ? e?.value : select === "PodID" ? 0 : 2,
      // });
      return;
    }
    const { name, value } = e?.target;
    if (name === "InmateResidentID") {
      const regex = /^[0-9\s]*$/;
      if (!regex.test(value)) return;
    }
    search[name] = value;
    dispatch(staffRequestAction?.setPrivateConversationSeachList(search));
    // dispatch(staffRequestAction?.setPrivateConversationSeachList(search));
    // setPrivateConversationSearch({
    //   ...privateConversationSearch,
    //   [name]: value,
    // });
  };

  const handleDateEnterKey = (event, name) => {
    if (event.key === "Enter") {
      const currentDate = new Date();

      // Set today's date using the same logic as your handleDateChange
      handleChange(currentDate, name);
    }

    const regex = /^[0-9/]$/; // Allow numbers and "/"

    if (
      !regex.test(event.key) &&
      event.key !== "Backspace" &&
      event.key !== "Delete" &&
      !(event.ctrlKey && event.key === "v")
    ) {
      event.preventDefault();
    }

    // Auto-insert '/' when typing
    const input = event.target.value;

    if (event.key !== "Backspace" && event.key !== "Delete") {
      if (input?.length === 2 || input?.length === 5) {
        event.target.value = input + "/";
      }
    }
  };

  const handleDateBlur = (e, fieldName) => {
    const search = { ...privateConversationSearchListData };
    let { value } = e.target;
    let isFromValid = true;
    let isToValid = true;

    if (fieldName === "RequestCreateStartDate") {
      if (
        search.RequestCreateEndDate &&
        new Date(value) > new Date(search.RequestCreateEndDate)
      ) {
        // Invalid: FromDate cannot be after ToDate
        isFromValid = false;
      }
    } else if (fieldName === "RequestCreateEndDate") {
      if (
        search.RequestCreateStartDate &&
        new Date(value) < new Date(search.RequestCreateStartDate)
      ) {
        // Invalid: ToDate cannot be before FromDate
        isToValid = false;
      }
    }

    // Define date format used
    const minDate = MinDate();
    const today = Today();
    const valueDate = new Date(value);
    const isValidDate = valueDate >= minDate && valueDate <= today;

    let updatedParam = {
      ...search,
      RequestCreateStartDate:
        fieldName === "RequestCreateStartDate"
          ? isFromValid && isValidDate
            ? value
            : ""
          : search.RequestCreateStartDate, // preserve existing value
      RequestCreateEndDate:
        fieldName === "RequestCreateEndDate"
          ? isToValid && isValidDate
            ? value
            : ""
          : search.RequestCreateEndDate, // preserve existing value
    };
    dispatch(staffRequestAction?.setPrivateConversationSeachList(updatedParam));
  };

  const handleResDateBlur = (e, fieldName) => {
    const search = { ...privateConversationSearchListData };
    let { value } = e.target;
    let isFromValid = true;
    let isToValid = true;

    if (fieldName === "RequestRespondStartDate") {
      if (
        search.RequestRespondEndDate &&
        new Date(value) > new Date(search.RequestRespondEndDate)
      ) {
        // Invalid: FromDate cannot be after ToDate
        isFromValid = false;
      }
    } else if (fieldName === "RequestRespondEndDate") {
      if (
        search.RequestRespondStartDate &&
        new Date(value) < new Date(search.RequestRespondStartDate)
      ) {
        // Invalid: ToDate cannot be before FromDate
        isToValid = false;
      }
    }

    // Define date format used
    const minDate = MinDate();
    const today = Today();
    const valueDate = new Date(value);
    const isValidDate = valueDate >= minDate && valueDate <= today;

    let updatedParam = {
      ...search,
      RequestRespondStartDate:
        fieldName === "RequestRespondStartDate"
          ? isFromValid && isValidDate
            ? value
            : ""
          : search.RequestRespondStartDate, // preserve existing value
      RequestRespondEndDate:
        fieldName === "RequestRespondEndDate"
          ? isToValid && isValidDate
            ? value
            : ""
          : search.RequestRespondEndDate, // preserve existing value
    };
    dispatch(staffRequestAction?.setPrivateConversationSeachList(updatedParam));
  };

  const handleSearchReset = () => {
    const searchData = { ...privateConversationSearchListData };
    searchData.FacilityID = facilityCode;
    searchData.InmatesId = 0;
    searchData.InmateResidentID = "";
    searchData.PodID = 0;
    searchData.InmateFirstName = "";
    searchData.InmateLastName = "";
    searchData.RequestCurrentStatus = 2;
    searchData.RequestCreateStartDate = "";
    searchData.RequestCreateEndDate = "";
    searchData.RequestRespondStartDate = "";
    searchData.RequestRespondEndDate = "";
    searchData.managementUserID = loggedUser;
    searchData.PageNo = 1;
    searchData.SortBy = "RequestCreateDate DESC";
    searchData.RowCountPerPage = 10;
    dispatch(staffRequestAction?.resetPrivateConversationSearchList());
    dispatch(staffRequestAction?.getPrivateConversationList(searchData));
    //update Notification
    dispatch(
      masterActions.GetLoadNotificationAlert({
        ManagementUserID: loggedUser,
        FacilityID: facilityCode,
      })
    )
      .then((response) => {
        const updatedMenuList =
          getStoredValue("menu_list") || response?.payload;

        if (updatedMenuList) {
          dispatch(authActions.updateMenuList(updatedMenuList));
        }
      })
      .then((x) => {
        dispatch(
          masterActions.GetPublicDefenderNotificationAlert({
            ManagementUserID: loggedUser,
            FacilityID: facilityCode,
          })
        ).then((response) => {
          const updatedMenuList =
            getStoredValue("menu_list") || response?.payload;

          if (updatedMenuList) {
            dispatch(authActions.updateMenuList(updatedMenuList));
          }
        });
      });
  };

  const viewForm = (row, formDetails) => {
    if (row?.IsAcceptPCR === 0) return;

    if (
      row?.RequestFormType >= 3 &&
      row?.RequestFormType !== 53 &&
      row?.RequestFormType !== 59 &&
      row?.RequestFormType !== 60
    ) {
      dispatch(staffRequestAction?.updateIndexValue(0));
      history.navigate("StaffRequestList/PrivateConversationRequestForm", {
        state: {
          formID: row?.RequestFormTypeID,
          RequestFormType: row?.RequestFormType,
          InmateID: row?.InmateID,
          InmateResidentId: row?.InmateResidentId,
          formDetails: formDetails,
          sourceFrom: "privateConversation",
        },
      });
    }
  };

  const handleReviewRequest = () => {
    if (
      privateConversationSearchListData?.RequestCurrentStatus !== 2 &&
      privateConversationSearchListData?.RequestCurrentStatus !== 3
    ) {
      showToastNotification(
        "There is no accepted requests in New status.",
        "error"
      );
      return;
    }

    const searchData = { ...privateConversationSearchListData };
    searchData.RowCountPerPage = privateConversationList?.TotalRecordCount;
    searchData.PageNo = 1;
    searchData.FacilityID = facilityCode;
    searchData.managementUserID = loggedUser;
    searchData.RequestCurrentStatus =
      searchData.RequestCurrentStatus === 3
        ? 2
        : searchData.RequestCurrentStatus;
    dispatch(
      staffRequestAction?.LoadPrivateConversationRequestReviewAllList(
        searchData
      )
    )
      .then((result) => {
        const data = result?.payload?.DataList;
        if (data?.length === 0) {
          showToastNotification(
            "There is no accepted requests in New status.",
            "error"
          );
          return;
        }
        setReviewFullData(data);
        viewForm(data[0], result?.payload);
        dispatch(staffRequestAction?.updateReviewStatus(true));
      })
      .catch((err) => {
        showToastNotification("Failed to get Request form data", "error");
      });
  };

  const exportDocAsExcel = () => {
    let generateExcelColumns = [
      "Conversation ID",
      "Inmate ID",
      "Inmate Full Name",
      "POD",
      "Created Date",
      "Respond By",
      "Respond On",
      "Status",
    ];

    const updateTotalRows = {
      ...privateConversationSearchListData,
      rowCountPerPage: privateConversationList?.TotalRecordCount,
      FacilityID: facilityCode,
      managementUserID: loggedUser,
      exportExcel: true,
      PageNo: 1,
    };

    dispatch(staffRequestAction?.getPrivateConversationList(updateTotalRows))
      .then((result) => {
        const dataList = result?.payload?.DataList;
        let exportData =
          result &&
          dataList?.map((obj) => ({
            "Conversation ID": obj.PCRequestID,
            "Inmate ID": obj.InmateResidentId,
            "Inmate Full Name": obj.InmateName,
            POD: obj.PodCode,
            "Created Date": obj.RequestCreateDate,
            "Respond By": obj.PCRAcceptedMGUFullname,
            "Respond On": obj.RequestRespondDate ? obj.RequestRespondDate : "-",
            Status: obj.RequestCurrentStatus,
          }));
        generateXlsx(
          exportData,
          generateExcelColumns,
          "Private_Conversation_Requests"
        );
      })
      .catch((err) => {
        showToastNotification("Error in Export Data", "error");
      });
  };

  const handleSearchSubmit = (e) => {
    e?.preventDefault();
    const searchData = { ...privateConversationSearchListData };
    searchData.FacilityID = facilityCode;
    searchData.PageNo = 1;
    searchData.RowCountPerPage = 10;
    searchData.managementUserID = loggedUser;
    dispatch(staffRequestAction?.getPrivateConversationList(searchData));
    dispatch(staffRequestAction?.setPrivateConversationSeachList(searchData));
    //updating notification
    dispatch(
      masterActions.GetLoadNotificationAlert({
        ManagementUserID: loggedUser,
        FacilityID: facilityCode,
      })
    )
      .then((response) => {
        const updatedMenuList =
          getStoredValue("menu_list") || response?.payload;

        if (updatedMenuList) {
          dispatch(authActions.updateMenuList(updatedMenuList));
        }
      })
      .then((x) => {
        dispatch(
          masterActions.GetPublicDefenderNotificationAlert({
            ManagementUserID: loggedUser,
            FacilityID: facilityCode,
          })
        ).then((response) => {
          const updatedMenuList =
            getStoredValue("menu_list") || response?.payload;

          if (updatedMenuList) {
            dispatch(authActions.updateMenuList(updatedMenuList));
          }
        });
      });
  };

  const handleNavigate = () => {
    dispatch(staffRequestAction?.resetPrivateConversationSearchList());
    history?.navigate("/Admin/StaffRequestList");
  };

  if (loading) return <CustomLoader />;

  const renderSearch = () => {
    return (
      <form onSubmit={(e) => handleSearchSubmit(e)}>
        <div className="row">
          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <DateInput
                label="Created Start Date"
                name="RequestCreateStartDate"
                handleChange={(e) => handleChange(e, "RequestCreateStartDate")}
                placeholderText="Select a date"
                value={
                  privateConversationSearchListData?.RequestCreateStartDate
                }
                yearDropDown={true}
                maxDate={
                  privateConversationSearchListData?.RequestCreateEndDate !== ""
                    ? privateConversationSearchListData?.RequestCreateEndDate
                    : getCurrentDate()
                }
                minDate={new Date(2017, 0, 1)}
                isClearable={
                  privateConversationSearchListData?.RequestCreateStartDate !==
                  ""
                }
                handleBlur={(e) => handleDateBlur(e, "RequestCreateStartDate")}
                handleKeyDown={(e) =>
                  handleDateEnterKey(e, "RequestCreateStartDate")
                }
              />
            </div>
          </div>
          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <DateInput
                label="Created End Date"
                name="RequestCreateEndDate"
                handleChange={(e) => handleChange(e, "RequestCreateEndDate")}
                placeholderText="Select a date"
                value={privateConversationSearchListData?.RequestCreateEndDate}
                yearDropDown={true}
                isClearable={
                  privateConversationSearchListData?.RequestCreateEndDate !== ""
                }
                maxDate={new Date()}
                minDate={
                  privateConversationSearchListData?.RequestCreateStartDate !==
                    ""
                    ? privateConversationSearchListData?.RequestCreateStartDate
                    : new Date(2017, 0, 1)
                }
                handleBlur={(e) => handleDateBlur(e, "RequestCreateEndDate")}
                handleKeyDown={(e) =>
                  handleDateEnterKey(e, "RequestCreateEndDate")
                }
              />
            </div>
          </div>
          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <SelectInput
                name="RequestCurrentStatus"
                options={RequestStatus}
                label="Status"
                value={privateConversationSearchListData?.RequestCurrentStatus}
                handleChange={(e) => handleChange(e, "RequestCurrentStatus")}
                isClearable={
                  privateConversationSearchListData?.RequestCurrentStatus !== 2
                }
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <DateInput
                label="Response Start Date"
                name="RequestRespondStartDate"
                handleChange={(e) => handleChange(e, "RequestRespondStartDate")}
                placeholderText="Select a date"
                value={
                  privateConversationSearchListData?.RequestRespondStartDate
                }
                yearDropDown={true}
                maxDate={
                  privateConversationSearchListData?.RequestRespondEndDate !==
                    ""
                    ? privateConversationSearchListData?.RequestRespondEndDate
                    : getCurrentDate()
                }
                minDate={new Date(2017, 0, 1)}
                isClearable={
                  privateConversationSearchListData?.RequestRespondStartDate !==
                  ""
                }
                handleBlur={(e) =>
                  handleResDateBlur(e, "RequestRespondStartDate")
                }
                handleKeyDown={(e) =>
                  handleDateEnterKey(e, "RequestRespondStartDate")
                }
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <DateInput
                label="Response End Date"
                name="RequestRespondEndDate"
                handleChange={(e) => handleChange(e, "RequestRespondEndDate")}
                value={privateConversationSearchListData?.RequestRespondEndDate}
                placeholderText="Select a date"
                yearDropDown={true}
                maxDate={new Date()}
                minDate={
                  privateConversationSearchListData?.RequestRespondStartDate !==
                    ""
                    ? privateConversationSearchListData?.RequestRespondStartDate
                    : new Date(2017, 0, 1)
                }
                isClearable={
                  privateConversationSearchListData?.RequestRespondEndDate !==
                  ""
                }
                handleBlur={(e) =>
                  handleResDateBlur(e, "RequestRespondEndDate")
                }
                handleKeyDown={(e) =>
                  handleDateEnterKey(e, "RequestRespondEndDate")
                }
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <SelectInput
                name="PodID"
                options={PODList}
                label="POD"
                value={privateConversationSearchListData?.PodID}
                handleChange={(e) => handleChange(e, "PodID")}
                isClearable={privateConversationSearchListData?.PodID}
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <TextInput
                name="InmateResidentID"
                label="Inmate ID"
                placeholder="Enter Inmate ID"
                handleChange={(e) => handleChange(e, "InmateResidentID")}
                value={privateConversationSearchListData?.InmateResidentID}
                maxLength={10}
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <TextInput
                name="InmateLastName"
                label="Inmate Last Name"
                placeholder="Enter Last Name"
                handleChange={(e) => handleChange(e, "InmateLastName")}
                value={privateConversationSearchListData?.InmateLastName}
                maxLength={50}
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <TextInput
                name="InmateFirstName"
                label="Inmate First Name"
                placeholder="Enter First Name"
                handleChange={(e) => handleChange(e, "InmateFirstName")}
                maxLength={50}
                value={privateConversationSearchListData?.InmateFirstName}
              />
            </div>
          </div>
        </div>

        <div className="d-flex flex-wrap justify-content-center gap-3 flex-wrap mt-3">
          <Button
            variant="primary"
            className="me-2"
            label={"SEARCH"}
            type={"submit"}
            status={"primary"}
            disabled={false}
            icon={"search"}
          />

          <Button
            variant="secondary"
            className="me-2"
            onClick={handleSearchReset}
            label={"RESET"}
            type={"button"}
            status={"secondary"}
            disabled={false}
            icon={"fa-solid fa-rotate-right"}
          />
        </div>
      </form>
    );
  };

  const toggleInformation = () => {
    setShowSearchFields((prev) => !prev);
  };

  return (
    <>
      <div className="private-conversation-request">
        <div className="d-flex flex-wrap flex-column justify-content-center align-items-center position-relative">
          {/* web only */}
          <div className="d-none d-md-block card shadow-sm b-r-all p-4 border border-dark-grey mt-3 me-3 w-100">
            <div className="d-flex gap-4 justify-content-between flex-basis-start align-items-start  mb-2">
              <h2 className=" text-color">
                PRIVATE CONVERSATION REQUEST SEARCH
              </h2>
              <Button
                label="Back"
                type="button"
                className={"flex-shrink-0"}
                icon={"fa-solid fa-angle-left"}
                status="primary"
                onClick={() => {
                  handleNavigate();
                }}
              />
            </div>
            {renderSearch()}
          </div>

          {/* Mobile only */}
          <div className="d-block d-md-none w-100 d-flex justify-content-end align-items-center mt-2">
            <Button
              label="Back"
              type="button"
              className={"flex-shrink-0"}
              icon={"fa-solid fa-angle-left"}
              status="primary"
              onClick={() => {
                handleNavigate();
              }}
            />
          </div>
          <div className="dd d-block d-md-none card shadow-sm b-r-all p-4 border border-dark-grey mt-3 me-3 w-100">
            <div className="row justify-content-end mb-2 d-none d-md-block">
              <div className="col-auto">
                <Button
                  label="Back"
                  type="button"
                  className={"flex-shrink-0"}
                  icon={"fa-solid fa-angle-left"}
                  status="primary"
                  onClick={() => {
                    handleNavigate();
                  }}
                />
              </div>
            </div>
            <div
              className=" d-flex align-items-center justify-content-between"
              style={{ background: "transparent", cursor: "pointer" }}
              onClick={toggleInformation}
            >
              <h2 className="form_title_uppercase text-color">
                PRIVATE CONVERSATION REQUESTS SEARCH
              </h2>
              <i
                id="itagInformation"
                className={`fa fa-angle-down ${showSearchFields ? "rotate" : ""
                  }`}
                style={{ fontSize: "20px" }}
              ></i>
            </div>
            {showSearchFields && renderSearch()}
          </div>

          <div className="card shadow-sm b-r-all p-4 border border-dark-grey mt-3 me-3  w-100">
            <div className="d-flex gap-4 flex-wrap justify-content-between flex-basis-start align-items-start  mb-2">
              <h2 className="text-color">PRIVATE CONVERSATION REQUESTS LIST</h2>
              {privateConversationList?.DataList?.length > 0 && (
                <>
                  <div className="d-flex flex-wrap gap-3 align-items-center">
                    {UserRoleID !== UserRoleType?.SuperAdmin && (
                      <Button
                        variant="secondary"
                        onClick={() => handleReviewRequest()}
                        className="me-2"
                        label="REVIEW REQUEST HERE"
                        type="button"
                        icon={"fa-solid fa-file-circle-check"}
                        status="secondary"
                        disabled={false}
                      />
                    )}

                    <ExcelExport handleExcelExport={exportDocAsExcel} />
                  </div>
                </>
              )}
            </div>

            <Table
              columns={columns}
              data={privateConversationList?.DataList}
              pagination
              onChangeRowsPerPage={handleRowPerPage}
              onChangePage={handlePageChange}
              totalRowCount={privateConversationList?.TotalRecordCount}
              currentPage={privateConversationSearchListData?.PageNo}
              paginationPerPage={
                privateConversationSearchListData.RowCountPerPage
              }
              serverSideSort
              onSort={handleSort}
              sortColumn={
                privateConversationSearchListData?.SortBy?.split(" ")[0]
              }
              sortDirection={
                privateConversationSearchListData?.SortBy?.split(" ")[1]
              }
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default React.memo(PrivateConversation);
